var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"querybar-mid"},_vm._l((_vm.classes),function(cls){return _c('categorybtn',{staticClass:"querybar-controls",attrs:{"title":_vm.lang(cls),"cls":cls,"icon":true},on:{"refreshUpdate":_vm.refreshUpdate}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }